<template>
  <div>
    <el-carousel trigger="click" :height="bannerHeight+'px'" arrow="hover">
      <el-carousel-item v-for="item in images" :key="item.url">
        <el-image class="image" :src="item.url"/>
      </el-carousel-item>
    </el-carousel>

    <div class="lmtit" style="margin-top: 50px">精选产品</div>
    <div class="lmxian"></div>
    <div class="production">
      <!--内容页-->
      <div class="content" :style="'height:auto;width:'+contentWidth+'%'">
        <el-tabs style="margin-left: 5px" tab-position="top">
          <el-tab-pane label="交流充电桩">
            <Pile14/>
          </el-tab-pane>
          <el-tab-pane label="直流充电桩120kw">
            <Pile120/>
          </el-tab-pane>
          <el-tab-pane label="直流充电桩240kw">
            <Pile240/>
          </el-tab-pane>
          <el-tab-pane label="直流充电堆">
            <Pile/>
          </el-tab-pane>
          <el-tab-pane label="储能50">
            <Store50/>
          </el-tab-pane>
          <el-tab-pane label="储能500">
            <Store500/>
          </el-tab-pane>
          <el-tab-pane label="储能系统">
            <SYSTEM/>
          </el-tab-pane>
          <el-tab-pane label="虚拟电厂">
            <VirtualStation/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--    应用模式-->
    <div class="application">
      <Application/>
    </div>
  </div>
</template>

<script>
import Pile14 from '../../components/production/pile/Pile14kw'
import Pile from '../../components/production/pile/Pile480kw'
import Pile120 from '../../components/production/pile/Pile120kw'
import Pile240 from '../../components/production/pile/Pile240kw'
import Store50 from '../../components/production/store/Store50kw'
import Store500 from '../../components/production/store/Store500kw'
import SYSTEM from '../../components/production/store/System'
import Application from '../../components/production/Application'
import VirtualStation from '../../components/production/virtual/Virtual'

export default {
  name: 'ProductionPage',
  components: {
    Pile14,
    Pile120,
    Pile240,
    Pile,
    Store50,
    Store500,
    SYSTEM,
    Application,
    VirtualStation
  },
  data () {
    return {
      contentWidth: 80,
      bannerHeight: '',
      images: [
        { url: require('@/assets/images/production/banner/储能页.jpg') },
        { url: require('@/assets/images/production/banner/充电桩页.jpg') },
      ],
      storeData: [
        '光储一体机',
        '储能变流器',
        '储能系统'
      ],
      pileData: [
        '交流14kw',
        '直流120kw',
        '直流240kw',
        '充电堆'
      ],
      tmpSelected: '00',
      tabsSelected: '0'
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      let clientWidth = document.documentElement.clientWidth
      this.bannerHeight = clientWidth * 937 / 1920
      if (clientWidth < 788) {
        this.contentWidth = 98
      } else {
        this.contentWidth = 80
      }
    }
  }
}
</script>

<style lang="less" scoped>
.lmtit {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
}

.lmxian {
  height: 1px;
  width: 60px;
  background: #287ab6;
  margin: 0 auto;
}

.production {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  .content {
    margin: 5px 0;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #dadde5;
    position: relative;
  }
}


</style>
